import { render, staticRenderFns } from "./SaleReport.vue?vue&type=template&id=96ac60b6&scoped=true"
import script from "./SaleReport.vue?vue&type=script&lang=js"
export * from "./SaleReport.vue?vue&type=script&lang=js"
import style0 from "./SaleReport.vue?vue&type=style&index=0&id=96ac60b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ac60b6",
  null
  
)

export default component.exports